import React from 'react';
import { FadeIn } from './FadeIn';
import { Utensils, ChefHat, RefreshCw, MapPin, GlassWater, Heart } from 'lucide-react';
export function PromiseSection() {
  const promises = [{
    icon: <Utensils className="text-olive-green" size={32} data-id="element-155" />,
    text: 'comer rico sin sabotear tu progreso'
  }, {
    icon: <ChefHat className="text-olive-green" size={32} data-id="element-156" />,
    text: 'preparar recetas simples y ligeras'
  }, {
    icon: <RefreshCw className="text-olive-green" size={32} data-id="element-157" />,
    text: 'hacer sustituciones que sí se sienten sostenibles'
  }, {
    icon: <MapPin className="text-olive-green" size={32} data-id="element-158" />,
    text: 'pedir mejor en restaurantes'
  }, {
    icon: <GlassWater className="text-olive-green" size={32} data-id="element-159" />,
    text: 'manejar fiestas, alcohol y compromisos sociales sin perder el control'
  }, {
    icon: <Heart className="text-olive-green" size={32} data-id="element-160" />,
    text: 'convertir esto en un estilo de vida real'
  }];
  return <section className="py-20 bg-warm-beige" data-id="element-161">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <FadeIn data-id="element-163">
          <div className="text-center mb-16" data-id="element-164">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-165">
              Con Sabores que Adelgazan aprenderás a:
            </h2>
            <div className="w-24 h-1 bg-olive-green mx-auto rounded-full" data-id="element-166"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-167">
          {promises.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-168">
              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow h-full flex flex-col items-center text-center border border-white/50" data-id="element-169">
                <div className="bg-warm-beige/50 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-170">
                  {item.icon}
                </div>
                <p className="text-lg font-medium text-gray-800 leading-snug" data-id="element-171">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}